import { ProColumns, ProTable } from '@ant-design/pro-components';
import { Breadcrumb, DatePicker, Drawer, Form, Input, Space, Table } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { observer } from 'mobx-react';
import { useState } from 'react';
// icons
import * as Icon from 'base/ui/components/Icons';
import { useTranslation } from 'react-i18next';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import CustomInputString from 'base/ui/components/Input/customInputString';
import CustomDatePicker from 'base/ui/components/Input/customDatePicker';
import { SYSTEM_TITLE } from 'utils/constants';

export type TableListItem = {
  key: number;
  stt: number;
  congty: string;
  maDK: string;
  maCRM: string;
  tenKH: string;
  sdt: string;
  maSAP: string;
  tenSP: string;
  soSerial: string;
  donHang: string;
  phieuGH: string;
  phieuBH: string;
  tenBH: string;
  ngayDk: string;
  BHdenngay: string;
  NNtruoc: string;
  soLanNN: number;
  ngayNN: string;
  ngayTTNN: string;
  trangthai: string;
  kqGuiTin: string;
};

const tableListDataSource: TableListItem[] = [
  {
    key: 1,
    stt: 1,
    congty: 'Công Ty TNHH Malloca Việt Nam',
    maDK: '128711',
    maCRM: '100448581',
    tenKH: 'Vũ Trà My',
    sdt: '0963240423',
    maSAP: '6100000098',
    tenSP: 'Bếp 3 từ, mã số MI 593B',
    soSerial: '220161000009800004',
    donHang: '20000076148',
    phieuGH: '70000087522',
    phieuBH: '100008722',
    tenBH: '12 Tháng',
    ngayDk: '01/01/2023',
    BHdenngay: '01/01/2023',
    NNtruoc: '30 Ngày',
    soLanNN: 0,
    ngayNN: '',
    ngayTTNN: '',
    trangthai: 'Chưa nhắc',
    kqGuiTin: '',
  },
  {
    key: 2,
    stt: 2,
    congty: 'Công Ty TNHH Malloca Việt Nam',
    maDK: '128711',
    maCRM: '100448581',
    tenKH: 'Hứa Minh Đạt',
    sdt: '0963240423',
    maSAP: '6100000098',
    tenSP: 'Bếp từ 2 bếp MH-7320 I (NK 2.0)',
    soSerial: '220161000009800004',
    donHang: '20000076148',
    phieuGH: '70000087522',
    phieuBH: '100008722',
    tenBH: '12 Tháng',
    ngayDk: '01/01/2023',
    BHdenngay: '01/01/2023',
    NNtruoc: '30 Ngày',
    soLanNN: 1,
    ngayNN: '05/07/2027',
    ngayTTNN: '05/07/2027',
    trangthai: 'Đã nhắc',
    kqGuiTin: 'Thành công',
  },
  {
    key: 3,
    stt: 3,
    congty: 'Công Ty TNHH Malloca Việt Nam',
    maDK: '128711',
    maCRM: '100448581',
    tenKH: 'Hứa Minh Đạt',
    sdt: '0963240423',
    maSAP: '6100000098',
    tenSP: 'Bếp 3 từ, mã số MI 593B',
    soSerial: '220161000009800004',
    donHang: '20000076148',
    phieuGH: '70000087522',
    phieuBH: '100008722',
    tenBH: '12 Tháng',
    ngayDk: '01/01/2023',
    BHdenngay: '01/01/2023',
    NNtruoc: '30 Ngày',
    soLanNN: 2,
    ngayNN: '15/07/2027',
    ngayTTNN: '',
    trangthai: 'Chưa nhắc',
    kqGuiTin: '',
  },
  {
    key: 4,
    stt: 4,
    congty: 'Công Ty TNHH Malloca Việt Nam',
    maDK: '128711',
    maCRM: '100448581',
    tenKH: 'Phan mạnh Hùng',
    sdt: '0963240423',
    maSAP: '6100000098',
    tenSP: 'Chậu rửa đôi cánh phải MS 1025R New',
    soSerial: '220161000009800004',
    donHang: '20000076148',
    phieuGH: '70000087522',
    phieuBH: '100008722',
    tenBH: '12 Tháng',
    ngayDk: '01/01/2023',
    BHdenngay: '01/01/2023',
    NNtruoc: '30 Ngày',
    soLanNN: 2,
    ngayNN: '05/07/2027',
    ngayTTNN: '05/07/2027 17:03',
    trangthai: 'Đã nhắc',
    kqGuiTin: 'Không thành công',
  },
  {
    key: 5,
    stt: 5,
    congty: 'Công Ty TNHH Malloca Việt Nam',
    maDK: '128711',
    maCRM: '100448581',
    tenKH: 'Phan mạnh Hùng',
    sdt: '0963240423',
    maSAP: '6100000098',
    tenSP: 'Bếp 3 từ, mã số MI 593B',
    soSerial: '220161000009800004',
    donHang: '20000076148',
    phieuGH: '70000087522',
    phieuBH: '100008722',
    tenBH: '12 Tháng',
    ngayDk: '01/01/2023',
    BHdenngay: '01/01/2023',
    NNtruoc: '30 Ngày',
    soLanNN: 0,
    ngayNN: '10/07/2023',
    ngayTTNN: '05/07/2023 17:03',
    trangthai: 'Đã nhắc',
    kqGuiTin: 'Thành công',
  },
];

export function createRemindList() {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.warranty') + ' - ' + SYSTEM_TITLE;

    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [selectRows, setSelectRows] = useState<TableListItem[]>([]);

    const showDrawer = () => {
      setOpen(true);
    };
    const onClose = () => {
      setOpen(false);
    };

    const handleSubmitMessage = () => {
      console.log(selectRows);
    };
    const columns: ProColumns<TableListItem>[] = [
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        fixed: true,
        width: 50,
        align: 'center',
      },
      {
        title: t('search-form.company'),
        dataIndex: 'congty',
        width: 200,
      },
      {
        title: t('remind-calendar.register-code'),
        dataIndex: 'maDK',
        width: 80,
      },
      {
        title: t('remind-calendar.crm-code'),
        dataIndex: 'maCRM',
      },
      {
        title: t('search-form.customer-name'),
        dataIndex: 'tenKH',
      },
      {
        title: t('remind-calendar.phone'),
        dataIndex: 'sdt',
      },
      {
        title: t('search-form.sap-product-code'),
        dataIndex: 'maSAP',
      },
      {
        title: t('search-form.product-name'),
        dataIndex: 'tenSP',
        width: 200,
      },
      {
        title: t('search-form.series'),
        dataIndex: 'soSerial',
      },
      {
        title: t('search-form.order'),
        dataIndex: 'donHang',
      },
      {
        title: t('search-form.delivery-note'),
        dataIndex: 'phieuGH',
      },
      {
        title: t('remind-calendar.guarantee-note'),
        dataIndex: 'phieuBH',
      },
      {
        title: t('search-form.guarantee-name'),
        dataIndex: 'tenBH',
      },
      {
        title: t('search-form.register-date'),
        dataIndex: 'ngayDk',
        align: 'center',
      },
      {
        title: t('remind-calendar.guarantee-form-date'),
        dataIndex: 'BHdenngay',
        align: 'center',
      },
      {
        title: t('remind-calendar.advance-warning'),
        dataIndex: 'NNtruoc',
      },
      {
        title: t('remind-calendar.remind-number'),
        dataIndex: 'soLanNN',
        width: 100,
        align: 'right',
      },
      {
        title: t('remind-calendar.remind-date-kh'),
        dataIndex: 'ngayNN',
        width: 100,
        align: 'center',
      },
      {
        title: t('remind-calendar.remind-date-tt'),
        dataIndex: 'ngayTTNN',
        align: 'center',
      },
      {
        title: t('zalo-notification.status'),
        dataIndex: 'trangthai',
      },
      {
        title: t('remind-calendar.send-results'),
        dataIndex: 'kqGuiTin',
      },
    ];

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.warranty'),
          },
        ]}
        extras={
          <>
            {/* <CustomButton onClick={handleSubmitMessage} type="primary" className="">
              Gửi tin nhắn
            </CustomButton> */}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Icon.Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        <BoxContainer fullHeight>
          <ProTable<TableListItem>
            columns={columns}
            rowSelection={{
              selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
              // defaultSelectedRowKeys: [0],
              onChange(selectedRowKeys, selectedRows, info) {
                setSelectRows(selectedRows);
              },
            }}
            size="small"
            bordered
            dataSource={tableListDataSource}
            scroll={{ x: 2800 }}
            // options={false}
            search={false}
            pagination={{
              pageSize: 5,
            }}
            rowKey="key"
            tableAlertOptionRender={() => {
              return null;
            }}
            toolBarRender={() => [
              <CustomButton
                onClick={() => {
                  handleSubmitMessage();
                }}
                type="primary"
                className=""
              >
                {t('btn.send-message')}
              </CustomButton>,
            ]}
            tableAlertRender={({ selectedRowKeys, selectedRows, onCleanSelected }) => {
              return (
                <Space size={24}>
                  <span>
                    {t('message.selected')} {selectedRowKeys.length} {t('message.item')}
                    <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                      {t('btn.cancel-selection')}
                    </a>
                  </span>
                </Space>
              );
            }}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox onClose={onClose} open={open}>
          <SearchForm form={form}>
            {/* Công ty */}
            <SearchItem label={t('search-form.company')} name={'congti'}>
              <CustomInputString />
            </SearchItem>
            {/* trạng thái gửi tin */}
            <SearchItem label={t('search-form.send-status')} name={'ttGuiTin'}>
              <CustomInputString />
            </SearchItem>
            {/* Mã CRM */}
            <SearchItem label={t('search-form.crm-customer-code')} name={'maCRM'}>
              <CustomInputString />
            </SearchItem>
            {/* Tên bảo hành */}
            <SearchItem label={t('search-form.guarantee-name')} name={'tenBH'}>
              <CustomInputString />
            </SearchItem>
            {/* Tên khách hàng */}
            <SearchItem label={t('search-form.customer-name')} name={'tenKH'}>
              <CustomInputString />
            </SearchItem>
            {/* Số se-ri */}
            <SearchItem label={t('search-form.series')} name={'soSerries'}>
              <CustomInputString />
            </SearchItem>
            {/* Mã SAP */}
            <SearchItem label={t('search-form.sap-product-code')} name={'maSAP'}>
              <CustomInputString />
            </SearchItem>
            {/* Đơn hàng */}
            <SearchItem label={t('search-form.order')} name={'donHang'}>
              <CustomInputString />
            </SearchItem>
            {/* Tên sản phẩm */}
            <SearchItem label={t('search-form.product-name')} name={'tenSP'}>
              <CustomInputString />
            </SearchItem>
            {/* Phiếu giao hàng */}
            <SearchItem label={t('search-form.delivery-note')} name={'phieuGH'}>
              <CustomInputString />
            </SearchItem>
            {/* Ngày đăng ký */}
            <SearchItem label={t('search-form.register-date')} name={'dateDK'}>
              <CustomDatePicker />
            </SearchItem>
            {/* Từ ngày  */}
            <SearchItem label={t('search-form.from')} name={'tuDK'} start>
              <CustomDatePicker />
            </SearchItem>
            {/* đến ngày */}
            <SearchItem label={t('search-form.to')} name={'denDK'}>
              <CustomDatePicker />
            </SearchItem>
            {/* Ngày đăng ký */}
            <SearchItem label={t('search-form.end-date')} name={'dateKT'}>
              <CustomDatePicker />
            </SearchItem>
            {/* Từ ngày */}
            <SearchItem label={t('search-form.from')} name={'tuKT'} start>
              <CustomDatePicker />
            </SearchItem>
            {/* Đến ngày */}
            <SearchItem label={t('search-form.to')} name={'denKT'}>
              <CustomDatePicker />
            </SearchItem>
            {/* Ngày nhắc nhở */}
            <SearchItem label={t('search-form.remind-date')} name={'dateDK'}>
              <CustomDatePicker />
            </SearchItem>
            {/* từ ngày  */}
            <SearchItem label={t('search-form.from')} name={'tuNN'} start>
              <CustomDatePicker />
            </SearchItem>
            {/* Đến ngày */}
            <SearchItem label={t('search-form.to')} name={'denNN'}>
              <CustomDatePicker />
            </SearchItem>
            {/* Nút tìm kiếm  */}
            <div className="col-span-4 sticky bottom-[-24px] py-2 bg-white w-full">
              <CustomButton htmlType="submit" className="my-auto" type="primary">
                {t('btn.search')}
              </CustomButton>
            </div>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
}

export default createRemindList;
